module.exports = __webpack_public_path__ + "static/front-6132bb51bd0ac699b549db2b3a0e9a31.jpg";